import { useLocation, useRoutes } from 'react-router-dom';
import RoutingHandler from 'src/router';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { CssBaseline } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
// import { RootState } from './redux-store/appStore';
// import { useSelector } from 'react-redux';

function App() {
  const location = useLocation();
  const dispatch = useDispatch();
  // const token = useSelector((store: RootState) => Object?.keys(store.user.userDetails)?.length);
  // const token = '';
  const router = RoutingHandler;
  const content = useRoutes(router);

  useEffect(() => {
    
  }, [location, dispatch]);

  return (
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <CssBaseline />
        <Toaster />
        {content}
      </LocalizationProvider>
    </ThemeProvider>
  );
}
export default App;
